enum DocumentType {
  'Certification document' = 'Certification document',
  'Annual report' = 'Annual report',
  'Project results update' = 'Project results update',
  'Project update' = 'Project update',
}

export default DocumentType
